export type PushType =
  | 'turn_reminder'
  | 'game_waiting'
  | 'table_ready'
  | 'rematch_request'
  | 'announcement'
  | 'festival';

/** FCM data payload. Values must be strings (FCM data messages). */
export interface PushData {
  type: PushType;
  /** Notification id for open attribution. */
  nid: string;
  /** Deep link path, e.g. /r/ABC234?src=push&nid=… */
  link: string;
  roomCode?: string;
}

export const PUSH_TOPICS = {
  announcements: 'announcements',
  festivals: 'festivals',
  lang: (code: string) => `lang_${code}`,
} as const;

export function pushLink(path: string, nid: string, type: PushType): string {
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}src=push&nid=${encodeURIComponent(nid)}&type=${type}`;
}
